<template>
  <section class="tkn-body" id="tkn-body">
    <div class="top-menu">
      <div class="header-nav flex-wrap clearfix">
        <div class="logo col-flex-1">
          <a href="/" title="一起学">
            <img title="一起科技" class="logo_img fixed" src="@/assets/17logo.png" alt="一起科技"
          /></a>
        </div>
      </div>
    </div>
    <AgreeContent></AgreeContent>
    <div class="tkn-footer" v-if="!isZhongHang">
      <Footer></Footer>
    </div>
  </section>
</template>
<script>
import { loadFromLocal, saveToLocal } from '@/utils/local'
import { api_post } from '@/utils/http.ts'
import { msgTip } from '@/utils/urlUtils'
import Footer from '@/components/Footer.vue'
import AgreeContent from './AgreeContent.vue'
export default {
  name: 'agree',
  data() {
    return {}
  },
  components: { AgreeContent, Footer },
  computed: {
    userInfo() {
      return this.$store.state.user_info
    },
    // 中行用户
    isZhongHang() {
      const zhongHangId = 'd5bf4a5ff8876b0f0b5a53f91b65c43a'
      return (
        this.userInfo &&
        this.userInfo.customer_ids &&
        this.userInfo.customer_ids.includes(zhongHangId)
      )
    }
  },
  methods: {},
  mounted() {}
}
</script>
<style lang="scss">
.top-menu {
  .subject-dropdown {
    width: 500px;
    height: 0px;
    overflow: hidden;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    border-radius: 2px;
    position: absolute;
    transition: height 0.3s ease;
    top: 100%;
    left: 0;
    z-index: 1000;
    float: right;
    text-align: left;
    border-radius: 2px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    -webkit-box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.16);
    .left-item {
      vertical-align: top;
      width: 10%;
      display: inline-block;
      height: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: gray;
      line-height: 22px;
    }
    .right-item {
      width: 90%;
      display: inline-block;
      height: 22px;
      span {
        padding: 0px 20px 20px 0px;
        display: inline-block;
        font-size: 14px;
      }
      .active-subject {
        color: rgba(0, 122, 255, 1);
      }
    }
  }
  .log-btns {
    button {
      height: 35px;
      width: 65px;
    }
    text-align: right;
  }
  .log-btns button:nth-child(2) {
    margin-right: 30px;
  }
  height: 64px;
  z-index: 9999;
  background: #fff;
  width: 100%;
  .header-nav {
    height: 64px;
    margin: 0px 128px 0px 128px;
    position: relative;
    z-index: 2;
    .header-cont {
      height: 64px;
      width: 83%;
    }
    .logo {
      max-width: 100px;
      line-height: 64px;
      .logo_img {
        width: 79px;
        height: 30px;
        line-height: 80px;
      }
    }
  }
}
</style>
